var render, staticRenderFns
import script from "./material_group_management.vue?vue&type=script&lang=js"
export * from "./material_group_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da1ede1')) {
      api.createRecord('2da1ede1', component.options)
    } else {
      api.reload('2da1ede1', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/material_group_management/material_group_management.vue"
export default component.exports